import React__default from 'react';

var Address = function Address(_ref) {
  var address = _ref.address;
  return /*#__PURE__*/React__default.createElement("address", {
    "automation-id": "contact-card-address",
    className: "flex flex-col not-italic"
  }, address && address.map(function (addressLine, index) {
    return /*#__PURE__*/React__default.createElement("p", {
      className: "line-clamp-2",
      title: addressLine,
      key: index
    }, addressLine);
  }));
};

export { Address };
//# sourceMappingURL=address-container.esm.js.map
